var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 67,
    viewBox: "0 0 42 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0372 66.7306H9.08776C5.43074 66.7306 2.43066 63.7589 2.43066 60.0881V7.69141H38.6724V60.0881C38.6724 63.7371 35.6942 66.7306 32.0153 66.7306H32.0372ZM4.27012 9.52682V60.0881C4.27012 62.732 6.43806 64.8951 9.08776 64.8951H32.0153C34.665 64.8951 36.8329 62.732 36.8329 60.0881V9.52682H4.27012Z",
    fill: "#1E1D1D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7525 20.9546H19.117C18.6133 20.9546 18.1973 20.5394 18.1973 20.0368C18.1973 19.5343 18.6133 19.1191 19.117 19.1191H37.7525C38.2561 19.1191 38.6722 19.5343 38.6722 20.0368C38.6722 20.5394 38.2561 20.9546 37.7525 20.9546Z",
    fill: "#1E1D1D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0446 20.9546H3.37285C2.86919 20.9546 2.45312 20.5394 2.45312 20.0368C2.45312 19.5343 2.86919 19.1191 3.37285 19.1191H12.0446C12.5483 19.1191 12.9643 19.5343 12.9643 20.0368C12.9643 20.5394 12.5483 20.9546 12.0446 20.9546Z",
    fill: "#1E1D1D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6941 57.0073C29.1905 57.0073 28.7744 56.5922 28.7744 56.0896V50.6926C28.7744 50.1901 29.1905 49.7749 29.6941 49.7749C30.1978 49.7749 30.6139 50.1901 30.6139 50.6926V56.0896C30.6139 56.5922 30.1978 57.0073 29.6941 57.0073Z",
    fill: "#1E1D1D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1824 48.9228C15.6788 48.9228 15.2627 48.5077 15.2627 48.0051V42.6081C15.2627 42.1056 15.6788 41.6904 16.1824 41.6904C16.6861 41.6904 17.1022 42.1056 17.1022 42.6081V48.0051C17.1022 48.5077 16.6861 48.9228 16.1824 48.9228Z",
    fill: "#1E1D1D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0008 38.1284C26.4971 38.1284 26.0811 37.7132 26.0811 37.2107V31.8137C26.0811 31.3111 26.4971 30.896 27.0008 30.896C27.5044 30.896 27.9205 31.3111 27.9205 31.8137V37.2107C27.9205 37.7132 27.5044 38.1284 27.0008 38.1284Z",
    fill: "#1E1D1D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1824 27.3564C15.6788 27.3564 15.2627 26.9413 15.2627 26.4387V21.0417C15.2627 20.5392 15.6788 20.124 16.1824 20.124C16.6861 20.124 17.1022 20.5392 17.1022 21.0417V26.4387C17.1022 26.9413 16.6861 27.3564 16.1824 27.3564Z",
    fill: "#1E1D1D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2053 1.83541H0.91973C0.416068 1.83541 0 1.42026 0 0.917707C0 0.415153 0.416068 0 0.91973 0H40.2053C40.709 0 41.1251 0.415153 41.1251 0.917707C41.1251 1.42026 40.709 1.83541 40.2053 1.83541Z",
    fill: "#1E1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrinkIcon);
export default __webpack_public_path__ + "static/media/drink-icon.a0014cfdc22457f87b268333e9fd0749.svg";
export { ForwardRef as ReactComponent };